document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.getElementById("CustomCartDrawer");
    const overlay = document.getElementById("CustomCartOverlay");

    if (!drawer || !overlay) return;

    /*-----------------------
        Open
    -----------------------*/

    function openCart() {
        drawer.classList.add("active");
        overlay.classList.add("active");
        document.body.classList.add("cart-open");
        document.body.style.overflow = "hidden";
        loadCart();
    }

    /*-----------------------
        Close
    -----------------------*/

    function closeCart() {
        drawer.classList.remove("active");
        overlay.classList.remove("active");
        document.body.classList.remove("cart-open");
        document.body.style.overflow = "";
    }

    /*-----------------------
        Click Events
    -----------------------*/

   document.addEventListener("click", function (e) {

   const upsellButton = e.target.closest(".cd-up-btn");

if (upsellButton) {

    e.preventDefault();
    e.stopPropagation();

    const upsell = upsellButton.closest(".cd-up");

    const productId = upsellButton.dataset.productId;
    const variantId = upsellButton.dataset.variantId;

    const qtyElement = upsell?.querySelector(".cd-up-qty");

    const quantity = parseInt(
        qtyElement?.textContent.trim() || "1",
        10
    );

    console.log("================================");
    console.log("UPSELL CLICK");
    console.log("Product ID:", productId);
    console.log("Variant ID:", variantId);
    console.log("Quantity:", quantity);
    console.log("================================");

    if (!variantId) {
        console.error("Variant ID missing");
        return;
    }

    upsellButton.disabled = true;
    upsellButton.textContent = "Adding...";

    fetch("/cart/add.js", {
        method: "POST",

        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },

        body: JSON.stringify({
            items: [
                {
                    id: Number(variantId),
                    quantity: quantity
                }
            ]
        })
    })
    .then(response => {

        if (!response.ok) {
            return response.json().then(error => {
                throw new Error(
                    error.description ||
                    "Could not add product"
                );
            });
        }

        return response.json();
    })
    .then(data => {

        console.log("Upsell added:", data);

        upsellButton.textContent = "Added";

        loadCart();
    })
    .catch(error => {

        console.error("Upsell error:", error);

        upsellButton.disabled = false;
        upsellButton.textContent = "Add";
    });

    return;
}



    /* =====================================================
       UPSELL QUANTITY MINUS
    ===================================================== */

    const upMinus =
        e.target.closest(".cd-up-minus");


    if (upMinus) {

        e.preventDefault();
        e.stopPropagation();


        /*
         * Find THIS upsell.
         */

        const upsell =
            upMinus.closest(".cd-up");


        if (!upsell) {
            return;
        }


        /*
         * Find quantity inside THIS upsell.
         */

        const qtyElement =
            upsell.querySelector(".cd-up-qty");


        const minusButton =
            upsell.querySelector(".cd-up-minus");


        if (!qtyElement) {
            return;
        }


        let quantity =
            parseInt(
                qtyElement.textContent.trim(),
                10
            ) || 1;


        quantity =
            Math.max(
                1,
                quantity - 1
            );


        qtyElement.textContent =
            quantity;


        if (minusButton) {

            minusButton.disabled =
                quantity <= 1;

        }


        console.log(
            "Upsell quantity:",
            quantity
        );


        return;
    }


    /* =====================================================
       UPSELL QUANTITY PLUS
    ===================================================== */

    const upPlus =
        e.target.closest(".cd-up-plus");


    if (upPlus) {

        e.preventDefault();
        e.stopPropagation();


        /*
         * Find THIS upsell.
         */

        const upsell =
            upPlus.closest(".cd-up");


        if (!upsell) {
            return;
        }


        /*
         * Find quantity inside THIS upsell.
         */

        const qtyElement =
            upsell.querySelector(".cd-up-qty");


        const minusButton =
            upsell.querySelector(".cd-up-minus");


        if (!qtyElement) {
            return;
        }


        let quantity =
            parseInt(
                qtyElement.textContent.trim(),
                10
            ) || 1;


        quantity++;


        qtyElement.textContent =
            quantity;


        if (minusButton) {

            minusButton.disabled =
                quantity <= 1;

        }


        console.log(
            "Upsell quantity:",
            quantity
        );


        return;
    }


    /* =====================================================
       CART ICON
    ===================================================== */

    const cartIcon =
        e.target.closest(".header-icon");


    if (cartIcon) {

        if (
            window.location.pathname === "/cart" ||
            window.location.pathname === "/cart/"
        ) {

            return;

        }


        e.preventDefault();

        openCart();

        return;
    }


    /* =====================================================
       CLOSE CART
    ===================================================== */

    if (
        e.target.closest(".custom-cart-close") ||
        e.target === overlay
    ) {

        closeCart();

        return;
    }


    /* =====================================================
       NORMAL CART PLUS
    ===================================================== */

    const plus =
        e.target.closest(".qty-plus");


    if (plus) {

        const key =
            plus.dataset.key;


        updateQty(
            key,
            1
        );


        return;
    }


    /* =====================================================
       NORMAL CART MINUS
    ===================================================== */

    const minus =
        e.target.closest(".qty-minus");


    if (minus) {

        const key =
            minus.dataset.key;


        updateQty(
            key,
            -1
        );


        return;
    }


    /* =====================================================
       REMOVE CART ITEM
    ===================================================== */

    const remove =
        e.target.closest(".cart-remove");


    if (remove) {

        removeItem(
            remove.dataset.key
        );

        return;
    }

});


    /*-----------------------
        Load Cart
    -----------------------*/

    function loadCart() {

        fetch("/cart.js")
            .then(res => res.json())
            .then(renderCart)
            .then(updateCartCount);

    }

/* Upsell Add */



    /*-----------------------
        Render
    -----------------------*/

    function renderCart(cart) {

        const body = drawer.querySelector(".custom-cart-body");

        const footer = drawer.querySelector(".custom-cart-footer");

        let html = "";

       const shipping = drawer.querySelector(".cart-shipping");

        if (!cart.items.length) {

            shipping.style.display = "none";
            footer.style.display = "none";

            body.innerHTML = `
                <div class="cart-empty">
                    <h3>Your cart is empty</h3>
                    <a href="/collections/all">Continue Shopping</a>
                </div>
            `;

            return;
        }

        shipping.style.display = "block";
        footer.style.display = "";

        footer.style.display = "";
        html += `<div class="cd-ship">Congratulations! You have free delivery!
        <div class="cd-shipbar go"><span class="tr"></span><span class="tk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"></path><circle cx="7" cy="17.5" r="1.6"></circle><circle cx="17.5" cy="17.5" r="1.6"></circle></svg></span></div>
      </div>
      <div class="cd-note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 8v5"></path><circle cx="12" cy="16.2" r=".4" fill="currentColor"></circle></svg><span><b>Items in your cart aren't reserved.</b> Checkout now so you don't miss out.</span></div>
`;
let i = 1;
        cart.items.forEach(item => {

            html += `
<div class="cart-item cd-item" data-key="${item.key}" id="cdItem${i}">

    <div class="cart-image">

        <img src="${item.image}" alt="" id="cdImg"  >

    </div>

    <div class="cart-info">

        <div class="cart-top nm">

            <h4>${item.product_title}</h4>
             </div>
            <div class="cart-price pr">
<span class="now" id="cdPrice">
                ${(item.final_line_price / 100).toLocaleString("en-AU", {
                    style: "currency",
                    currency: Shopify.currency.active
                })}
</span>
            </div>
            <button
                class="cart-remove cd-del"
                data-key="${item.key}">

                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">

                    <path d="M5 5L15 15"
                        stroke="currentColor"
                        stroke-width="1.5"/>

                    <path d="M15 5L5 15"
                        stroke="currentColor"
                        stroke-width="1.5"/>

                </svg>

            </button>

       

        ${
            item.variant_title &&
            item.variant_title !== "Default Title"
                ? `<div class="cart-variant">${item.variant_title}</div>`
                : ""
        }

        <div class="cart-bottom-row cd-qtyrow">

            <div class="cart-qty cd-qty">

                <button
                    class="qty-minus"
                    data-key="${item.key} id="cdMinus">
                    −
                </button>

                <span>${item.quantity}</span>

                <button
                    class="qty-plus"
                    data-key="${item.key}">
                    +
                </button>

            </div>

            

        </div>

    </div>

</div>

`;
                

i++;

        });

    const hasOlympiaGenesis = cart.items.some(item =>
    item.product_title
        ?.trim()
        .toLowerCase()
        .includes("olympia genesis")
);


// Select upsell based on cart
const upsellProductId = hasOlympiaGenesis
    ? 10394355892504
    : 10005126578456;


// Check if the selected upsell is already in cart
const upsellAlreadyInCart = cart.items.some(item =>
    String(item.product_id) === String(upsellProductId)
);


console.log("Olympia Genesis:", hasOlympiaGenesis);
console.log("Selected upsell product:", upsellProductId);
console.log("Upsell already in cart:", upsellAlreadyInCart);


if (!upsellAlreadyInCart) {

    if (hasOlympiaGenesis) {

        // ==============================
        // RED LIGHT THERAPY
        // ==============================

        html += `

            <div class="cd-up">

                <div class="ul">
                    Complete your sauna experience
                </div>

                <div class="cd-upcard">

                    <img
                        src="https://cdn.shopify.com/s/files/1/0751/6425/4488/files/p_image.png?v=1787892702"
                        alt="Red-light therapy panel"
                    >

                    <div style="flex:1;min-width:0">

                        <div style="display:flex;gap:10px">

                            <div class="un">
                                Red-Light Therapy Panel
                            </div>

                            <div class="up">
                                $1,000
                            </div>

                        </div>

                        <div class="cd-uprow">

                            <div class="cd-upqty">

                                <button
                                    type="button"
                                    class="cd-up-minus"
                                    aria-label="Decrease quantity"
                                    disabled>
                                    −
                                </button>

                                <span class="q cd-up-qty">1</span>

                                <button
                                    type="button"
                                    class="cd-up-plus"
                                    aria-label="Increase quantity">
                                    +
                                </button>

                            </div>

                            <button
                                type="button"
                                class="add cd-up-btn"
                                data-product-id="10394355892504" data-variant-id="52581012668696">
                                Add
                            </button>

                        </div>

                    </div>

                </div>

            </div>

        `;

    } else {

        // ==============================
        // HEALIOS COMPRESSION BOOTS
        // ==============================

        html += `

            <div class="cd-up">

                <div class="ul">
                    Complete your sauna experience
                </div>

                <div class="cd-upcard">

                    <img
                        src="https://cdn.shopify.com/s/files/1/0751/6425/4488/files/Healios_Compression_Boots_Comfort.jpg?v=1776144583"
                        alt="Healios Compression Boots"
                    >

                    <div style="flex:1;min-width:0">

                        <div style="display:flex;gap:10px">

                            <div class="un">
                                Healios Compression Boots
                            </div>

                            <div class="up">
                                $690
                            </div>

                        </div>

                        <div class="cd-uprow">

                            <div class="cd-upqty">

                                <button
                                    type="button"
                                    class="cd-up-minus"
                                    aria-label="Decrease quantity"
                                    disabled>
                                    −
                                </button>

                                <span class="q cd-up-qty">1</span>

                                <button
                                    type="button"
                                    class="cd-up-plus"
                                    aria-label="Increase quantity">
                                    +
                                </button>

                            </div>

                            <button
                                type="button"
                                class="add cd-up-btn"
                                data-product-id="10005126578456" data-variant-id="52499062063384">
                                Add
                            </button>

                        </div>

                    </div>

                </div>

            </div>

        `;

    }

}


        body.innerHTML = html;

        drawer.querySelector(".cart-subtotal").innerHTML =
            (cart.total_price / 100).toLocaleString("en-AU", {
                style: "currency",
                currency: Shopify.currency.active
            });

    }
    

    /*-----------------------
        Update Qty
    -----------------------*/

    function updateQty(key, change) {

        fetch("/cart.js")
            .then(r => r.json())
            .then(cart => {

                const item = cart.items.find(i => i.key === key);

                if (!item) return;

                let qty = item.quantity + change;

                if (qty < 1) qty = 0;

                fetch("/cart/change.js", {

                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({

                        id: key,

                        quantity: qty

                    })

                })
                    .then(r => r.json())
                    .then(renderCart)
                    .then(updateCartCount);

            });

    }

    /*-----------------------
        Remove
    -----------------------*/

    function removeItem(key) {

        fetch("/cart/change.js", {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify({

                id: key,

                quantity: 0

            })

        })
            .then(r => r.json())
            .then(renderCart)
            .then(updateCartCount);

    }

    /*-----------------------
        Auto Open
    -----------------------*/

    document.addEventListener("cart:refresh", () => {

        openCart();

    });

    document.addEventListener("ajaxProduct:added", () => {

        openCart();

    });

    window.openOlympiaCart = openCart;

});
function updateCartCount() {
    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {

            const countElement = document.getElementById("cdCount");

            if (!countElement) return;

            countElement.textContent = `(${cart.item_count})`;

        })
        .catch(error => {
            console.error("Cart count error:", error);
        });
}
updateCartCount();
